var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-list-item-avatar"},[_c('b2b-avatar',{attrs:{"src":_vm.src,"size":"38","flat":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }